import React, { useEffect, useState } from 'react';
import { QueryClient, QueryClientProvider } from 'react-query';
import Auth from './components/Auth';
import './App.less';
import { createGlobalStyle } from 'styled-components';

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: false,
    },
  },
});

const App = () => {
  const [theme, setTheme] = useState<any>({
    themename: 'default',
    primarycolor: '#243782',
    primarycolorlight: '#146e63',
    secondarycolor: '#f6bd60',
    bordercolor: '#daf0ee',
    textcolor: '#FFF',
    linkcolor: '#00A896',
    logo: 'utinaPlatformLogo.png',
    fontface: '',
  });

  useEffect(() => {
    let them =
      localStorage?.getItem('theme') === 'undefined' ||
      localStorage?.getItem('theme') == null
        ? JSON.stringify(theme)
        : localStorage?.getItem('theme') ?? '{}';
    const newTheme = JSON?.parse(them);
    setTheme({
      themename: '',
      primarycolor: newTheme?.primarycolor ?? '#00925b',
      primarycolorlight: newTheme?.primarycolorlight ?? '#146e63',
      secondarycolor: newTheme?.secondarycolor ?? '#f6bd60',
      bordercolor: newTheme?.bordercolor ?? '#daf0ee',
      textcolor: newTheme?.textcolor ?? '#37474f',
      linkcolor: newTheme?.linkcolor ?? '#00925b',
      fontface: '',
    });
  }, [localStorage.getItem('theme')]);

  // useEffect(() => {
  //   if (localStorage.getItem('SSO') !== 'true') {
  //     localStorage.setItem('SSO', 'true');
  //     window.location.replace('http://82.165.183.200:9205/saml/login');
  //   }
  // }, []);

  const GlobalStyle = createGlobalStyle`
  a {
    color:${theme?.linkcolor};
  }
  .ant-input {
    border-color: ${theme?.bordercolor};
  }
  .ant-input-number {
    border-color: ${theme?.bordercolor} !important;
  }
  .ant-select-selector {
    border-color: ${theme?.bordercolor} !important;
  }
  .ant-card {
    border-color: ${theme?.bordercolor};
  }

  .ant-btn-primary {
    border-color:${theme?.primarycolor} !important;
    border-color:${theme?.primarycolor} !important;
    background:${theme?.primarycolor} !important;
  }

  .ant-btn-dangerous  {
    border-color: #f5222d !important;
    background: #f5222d !important;
    color: #fff !important;
  }

  .ant-menu > .ant-menu-item-open, .ant-menu> .ant-menu-submenu-open:hover {
    color: #fff !important;
    background:${theme?.primarycolorlight} !important;
  }
  
  .ant-menu-item-selected {
    color: #fff !important;
    border-right: 0;
    background:${theme?.primarycolorlight} !important;
  }
  .ant-dropdown-menu-item-selected, .ant-dropdown-menu-submenu-title-selected{
    background-color:${theme?.secondarycolor} !important;
  }
  .ant-dropdown-menu-item:hover, .ant-dropdown-menu-submenu-title:hover,
  .ant-dropdown-menu-item.ant-dropdown-menu-item-active, 
  .ant-dropdown-menu-item.ant-dropdown-menu-submenu-title-active, 
  .ant-dropdown-menu-submenu-title.ant-dropdown-menu-item-active, 
  .ant-dropdown-menu-submenu-title.ant-dropdown-menu-submenu-title-active {
     color:${theme?.secondarycolor} !important;
  }
  
  .ant-menu-item-myProfile, .span.ant-dropdown-menu-title-content  {
    font-weight: 500 !important;
  }
 
  .ant-checkbox-indeterminate .ant-checkbox-inner::after {
    top: 50%;
    left: 50%;
    width: 8px;
    height: 8px;
    background-color: ${theme?.primarycolor} !important;
    border: 0;
    transform: translate(-50%, -50%) scale(1);
    opacity: 1;
    content: ' ';
  }
  .ant-menu-item-active{
    color: #fff !important;
    border-right: 0;
    background:${theme?.primarycolorlight} !important;
  }

  /* Style for the selected radio button */
  .radio-button-checked {
    background-color:${theme?.primarycolor} !important;
    color: #fff;
  }

  .ant-checkbox-checked .ant-checkbox-inner {
    background-color:${theme?.primarycolor} !important;
    border-color: ${theme?.primarycolor} !important;
  }

  ul.ant-menu-overflow.ant-menu.ant-menu-root.ant-menu-horizontal.ant-menu-dark.menu-style {
  background-color: ${theme?.primarycolor} !important;
  }


  .ant-table-tbody > tr.ant-table-row-selected > td {
    background:  ${theme?.bordercolor} !important;
    border-color: ${theme?.primarycolor} !important;
  }


  .ant-checkbox-inner {
    position: relative;
    top: 0;
    left: 0;
    display: block;
    width: 19px;
    height: 19px;
    direction: ltr;
    background-color: #fff;
    border: 3px solid ${theme?.primarycolor} !important;
    border-radius: 2px;
    border-collapse: separate;
    transition: all 0.3s;
  }

  .radio-button {
    padding: 4px 29px;
    margin: 0px;
    background-color: #fff;
    border: 1px solid ${theme?.bordercolor} !important;
    cursor: pointer;
    text-align: center;
  }

  .utinaCard{
    border-color: ${theme?.bordercolor} !important;
  }

  .ant-picker {
    border-color: ${theme?.bordercolor} !important;
  }

  .ant-switch-checked {
    background-color:${theme?.primarycolor} !important; 
  }

  .ant-tabs-tab.ant-tabs-tab-active .ant-tabs-tab-btn {
    color:${theme?.primarycolor}!important;
  }

  .ant-steps-item-process > .ant-steps-item-container > .ant-steps-item-icon {
    background:${theme?.primarycolor} !important; 
    border-color: ${theme?.primarycolor} !important;
  }

  .proposal-catalog{
    background:${theme?.primarycolorlight} !important; 
  }

  .ant-input:hover {
    border-color: ${theme?.primarycolor} !important;
    border-right-width: 1px !important;
  }
  .ant-input:focus, .ant-input-focused {
    border-color: ${theme?.primarycolor} !important;;
    box-shadow: 0 0 0 2px ${theme?.bordercolor} !important;
  }

  .ant-input:focus, .ant-input-focused {
    border-color: ${theme?.primarycolor} !important;;
    box-shadow: 0 0 0 2px ${theme?.bordercolor} !important;
  }

  .ant-menu-submenu-title span {
    color: ${theme?.textcolor} !important;
  }

  .ant-menu-dark .ant-menu-item a {
    color: ${theme?.textcolor} !important;
  }
  .anticon::before {
    color: blue !important;
  }

  .ant-table-cell-primary{
    background:${theme?.primarycolor} !important; 
  }

  .ant-tabs-bar {
    border-bottom: 1px solid :${theme?.primarycolor} !important; 
  }

  .ant-layout-sider {
    background-color:  ${theme?.primarycolor} !important;
    color: #fff !important; 
  }

  .menu-style {
    background: ${theme?.primarycolor} !important;
    color:${theme?.textcolor} !important;
  }


  .menu-style .ant-dropdown-menu-title-content {
    flex: auto;
    color:${theme?.textcolor} !important;
}

  // .first-column {
  // background: ${theme?.primarycolor} !important;
  // }

  .title-second{
  color:${theme?.primarycolor}!important;
  }

.ant-spin-dot-item {
  background-color:${theme?.primarycolor}!important;
}

.ant-menu-item-selected, .ant-menu-submenu-selected {
  border-bottom: solid ${theme?.secondarycolor} 4px !important;
}

.ant-radio-group-solid .ant-radio-button-wrapper-checked:not(.ant-radio-button-wrapper-disabled) {
  color: #fff;
  background: ${theme?.primarycolor} !important;
  border-color: ${theme?.primarycolor} !important;
}

.ant-menu > .ant-menu-item-open,
.ant-menu> .ant-menu-submenu-open {
  background: ${theme?.primarycolor} !important;
  color:#fff  !important;
}

.ant-menu.ant-menu-dark, .ant-menu-dark .ant-menu-sub, .ant-menu.ant-menu-dark .ant-menu-sub{
  color: #fff;
  background:  ${theme?.primarycolor} !important;
}


.ant-menu ::-webkit-scrollbar-thumb {
  border-radius: 7px;
  background: ${theme?.primarycolorlight} !important;
}


.ant-tabs-ink-bar {
  background: ${theme?.primarycolor} !important;
}

.ant-drawer-header {
  background:  ${theme?.primarycolor} !important;
}
.ant-drawer-title{
  color: #fff !important;
}

.ant-radio-inner::after {

  background-color:${theme?.primarycolor} !important;

}


::selection {
  color: #fff;
  background: ${theme?.primarycolorlight} !important;
}


.rowColorTabModifReview {
  background: ${theme?.bordercolor} !important;
}

`;
  return (
    <QueryClientProvider client={queryClient}>
      <GlobalStyle />
      <Auth />
    </QueryClientProvider>
  );
};

export default App;
